<template>
  <a-button @click="handleSignOut" class="logout-btn">{{ $t('logout') }}</a-button>
</template>

<script>
import { mapActions } from 'vuex';
import { ROUTER_PATHS } from '@/router/constants';
import { SESSION_FINISHED } from '@/store/session/actionTypes';

export default {
  methods: {
    ...mapActions({
      signOut: SESSION_FINISHED,
    }),
    async handleSignOut() {
      await this.signOut();
      this.$router.push(ROUTER_PATHS.LOGIN);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.logout-btn {
  border: none;
  margin: 0;
  background-color: $light-orange;
  color: $orange;
}

@media (max-width: $header-breakpoint) {
  .logout-btn {
    margin-top: 10px;
  }
}
</style>
